import { ExchangeRateState } from 'Application/models';
import { ExchangeRateService } from 'Application/service';
import { create } from 'zustand';

export const useExchangeRateStore = create<ExchangeRateState>((set, get) => ({
    isLoading: false,
    isError: false,
    error: null,
    exchangeRate: null,
    allExchangeRates: null,

    getExchangeRate: async (fromCurrency: string, toCurrency: string) => {
        set({ isLoading: true });

        try {
            const response = await ExchangeRateService.getExchangeRate(fromCurrency, toCurrency);

            set({
                isError: false,
                error: null,
                exchangeRate: response
            });
        } catch (error) {
            set({ error: 'Failed to get the exchange rate', isError: true });
            throw error;
        } finally {
            set({ isLoading: false });
        }
    },

    getAllExchangeRates: async () => {
        set({ isLoading: true });

        try {
            const response = await ExchangeRateService.getAllExchangeRates();

            set({
                isError: false,
                error: null,
                allExchangeRates: response.data.exchangeRates
            });
        } catch (error) {
            set({ error: 'Failed to get all exchange rates', isError: true });
            throw error;
        } finally {
            set({ isLoading: false });
        }
    },

    updateExchangeRate: async (fromCurrency: string, toCurrency: string, rate: number) => {
        set({ isLoading: true });

        try {
            const response = await ExchangeRateService.updateExchangeRate(fromCurrency, toCurrency, rate);

            set({
                isError: false,
                error: null,
                exchangeRate: response
            });

            await get().getAllExchangeRates();
        } catch (error) {
            set({ error: 'Failed to update the exchange rate', isError: true });
            throw error;
        } finally {
            set({ isLoading: false });
        }
    },

    addExchangeRate: async (fromCurrency: string, toCurrency: string, rate: number) => {
        set({ isLoading: true });

        try {
            const response = await ExchangeRateService.addExchangeRate(fromCurrency, toCurrency, rate);

            set({
                isError: false,
                error: null,
                exchangeRate: response
            });

            await get().getAllExchangeRates();
        } catch (error) {
            set({ error: 'Failed to create the exchange rate', isError: true });
            throw error;
        } finally {
            set({ isLoading: false });
        }
    }
}));
